import { PageFrame } from "../../components/page_frame";
import { SupplyWalkNoPerspectiveContainer } from "./container";

export function SupplyWalkNoPerspectivePage() {
  return (
    <PageFrame>
      <SupplyWalkNoPerspectiveContainer />
    </PageFrame>
  );
}

export default SupplyWalkNoPerspectivePage;
